import { Component, OnInit, EventEmitter } from '@angular/core';
import { AuthService } from 'src/app/core/services/authentication.service';
import { Router } from '@angular/router';
import { User } from 'src/app/core/interfaces/user';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss'],
  providers: [AuthService]
})
export class HomeComponent implements OnInit {

  userData: User;

  constructor(private authService: AuthService, private router: Router) {}

  ngOnInit() {
    setTimeout(() => {
      const user = this.authService && this.authService.getUserSession();
      if (
        user.information.document &&
        user.state.active &&
        user.lastUserTerm &&
        !user.lastUserTerm.state
      ) {
        this.router.navigate(['/account/validate-terms']);
      }
    }, 200);
  }

}
